import { Component, OnInit, NgZone, Input } from '@angular/core';
import { GlobalVariablesService } from '../../services/global-variables.service';
import { TranslateConfigService } from '../../services/commons/translate-config.service';
import { GlobalMethodsService } from '../../services/global-methods.service';
import { ProfileInstallationService } from '../../services/commons/profile-installation.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Installation } from '../../models/Installation';
import { InstallationNameChangeRequest } from '../../services/SicorService/RequestObject/InstallationNameChangeRequest';

@Component({
  selector: 'app-installation-name',
  templateUrl: './installation-name.component.html',
  styleUrls: ['./installation-name.component.scss'],
})
export class InstallationNameComponent implements OnInit {

  public isServiceBusy = false;
  public installationNameForm: FormGroup;
  public userName: any;
  @Input('installation') installation: Installation;

  constructor(private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private profileInstallationService: ProfileInstallationService,
    public gms: GlobalMethodsService,
    private zone: NgZone,
    private translate: TranslateConfigService,
    private gvs: GlobalVariablesService) {}

  ngOnInit() {
    this.userName = this.gvs.user.userName;
    this.installationNameForm = this.formBuilder.group({
      alias_name: new FormControl(this.installation.alias, [Validators.required]),
    });
  }

  public async onSubmit() {
    if (this.isServiceBusy) {
      return;
    }
    this.gms.analyticsTrackEvent('installation_name', {eventCategory: 'SICOR/Modal Nombre Instalacion', eventAction: 'Accion/Cambiar Nombre Click'});
    if (this.installationNameForm.valid) {
      const checkInternet = await this.gms.checkInternet();
      if (checkInternet) {
        this.isServiceBusy = true;
        this.installationNameForm = this.gms.checkAllowedCharacters(this.installationNameForm);
        let requestParams = new InstallationNameChangeRequest(this.userName, this.installation.s_ins, this.installationNameForm.controls.alias_name.value);
        const response = await this.profileInstallationService.changeInstallationName(requestParams);
        if (response === undefined) {
          this.gms.analyticsTrackEvent('installation_name', {eventCategory: 'SICOR/Modal Nombre Instalacion', eventAction: 'Error/Modificar Nombre Instalacion'});
          return;
        }
        if (response) {
          this.gms.analyticsTrackEvent('installation_name', {eventCategory: 'SICOR/Modal Nombre Instalacion', eventAction: 'Accion/Modificar Nombre Instalacion'});
          await this.dismiss(true, true);
        } else {
            this.gms.analyticsTrackEvent('installation_name', {eventCategory: 'SICOR/Modal Nombre Instalacion', eventAction: 'Error/Modificar Nombre Instalacion'});
          await this.dismiss(true, false);
        }
        this.isServiceBusy = false;
      } else {
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    } else {
      this.validateAllFormFields(this.installationNameForm);
    }
  }

  isFieldValid(field: string) {
    return !this.installationNameForm.get(field).valid && this.installationNameForm.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (!control.valid){
         this.gms.analyticsTrackEvent('installation_name', {eventCategory: 'SICOR/Modal Nombre Instalacion', eventAction: 'Error/Form: Modificar Nombre Instalacion', eventLabel:'Campo: ' + field});
      }
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  dismiss(confirm: boolean, result: boolean) {
    this.modalCtrl.dismiss({ confirm: confirm, result: result});
  }

}
